import { useContext } from 'react';
import cn from 'classnames';
import { RelatedItems } from '../RelatedItems';
import { InternalLayoutContext } from './InternalLayoutProvider';
import { useHasSidebar } from './useHasSidebar';
import { getContentAreaClassName } from './contentAreaClassName';

/**
 * Moldura da página de sub-home.
 *
 * Mesma grade da `InternalLayout` (por isso as classes `mpf-internal-view__*`
 * são reaproveitadas: a coluna de conteúdo, a sidebar de slot e a
 * centralização sem sidebar são idênticas), com uma diferença: a sub-home
 * NÃO tem cabeçalho de página.
 *
 * No Figma a página abre direto no banner — sem o `h1` visível nem os botões
 * Imprimir/Compartilhar que o `PageTitle` traz. Mas uma página sem `h1`
 * começaria a árvore de headings no `h2` da primeira faixa, então o título do
 * conteúdo entra como `sr-only`, exatamente como a capa faz em
 * `View/CapaView/index.tsx`.
 */
export const SubHomeLayout = ({
  children,
  tituloOculto = true,
  className,
}: {
  children: React.ReactNode;
  /** Classe extra na moldura, para uma página ajustar as faixas só nela. */
  className?: string;
  /**
   * `false` quando um bloco da página já traz o `h1` visível (a busca da
   * página de serviços): dois `h1` confundiriam a árvore de headings.
   */
  tituloOculto?: boolean;
}) => {
  const { title, relatedItems, larguraTotal } = useContext(
    InternalLayoutContext,
  );
  const hasRelatedItems = !!relatedItems && relatedItems.length > 0;
  const hasSidebar = useHasSidebar(hasRelatedItems);

  return (
    <section
      id="main-content"
      className={cn('mpf-internal-view mpf-subhome', className)}
    >
      <div className="mpf-internal-view__grid">
        <article
          className={getContentAreaClassName({ hasSidebar, larguraTotal })}
        >
          <div className="mpf-internal-view__article">
            {tituloOculto && title && <h1 className="sr-only">{title}</h1>}
            {children}
          </div>
        </article>

        {hasRelatedItems && (
          <RelatedItems
            title="Links úteis"
            description="Acessos rápidos relacionados a esta página."
            relatedItems={relatedItems}
          />
        )}
      </div>
    </section>
  );
};

export default SubHomeLayout;
